import loadable from '@loadable/component';
import { WithLazyHydration } from '../../../WithLazyHydration';

const RelatedVideosLoadable = loadable(() => import('./RelatedVideos'), {
  resolveComponent: components => components.RelatedVideos
});

export const RelatedVideos = WithLazyHydration(RelatedVideosLoadable, {
  name: 'RelatedVideos'
});
